/**
 * Padrão de "rabiscos" divertidos da Salato (coxinha, bolinha, pastel, brilho, ondinha).
 * Desenho próprio, em SVG, usado como fundo repetido.
 * Uso em styled-components:  background-image: ${doodles('#ffffff', .08)};
 */
const tile = (stroke) => `
<svg xmlns='http://www.w3.org/2000/svg' width='220' height='220' viewBox='0 0 220 220' fill='none' stroke='${stroke}' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'>
  <g transform='rotate(-14 38 40)'>
    <path d='M38 18c9 12 17 24 17 35a17 17 0 0 1-34 0c0-11 8-23 17-35z'/>
    <path d='M31 52c4 3 10 3 14 0'/>
  </g>
  <circle cx='150' cy='36' r='13'/>
  <circle cx='146' cy='32' r='3'/>
  <path d='M98 92c0-15 12-26 28-26s28 11 28 26z'/>
  <path d='M107 88c2-9 9-15 19-15s17 6 19 15' stroke-dasharray='3 5'/>
  <path d='M190 104l4 10 10 4-10 4-4 10-4-10-10-4 10-4z'/>
  <path d='M20 126c8-8 16 8 24 0s16 8 24 0'/>
  <circle cx='86' cy='160' r='9'/>
  <circle cx='104' cy='170' r='6'/>
  <path transform='rotate(18 168 190)' d='M168 168c8 11 15 21 15 30a15 15 0 0 1-30 0c0-9 7-19 15-30z'/>
  <circle cx='60' cy='204' r='2.5' fill='${stroke}'/>
  <circle cx='124' cy='130' r='2.5' fill='${stroke}'/>
  <circle cx='200' cy='60' r='2.5' fill='${stroke}'/>
  <circle cx='16' cy='88' r='2.5' fill='${stroke}'/>
</svg>`;

// codifica também ( ) ' para não confundir o parser de CSS do styled-components
const encodeSvg = (svg) => encodeURIComponent(svg)
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/'/g, '%27');

export const doodles = (color = '#ffffff', opacity = 0.1) => {
    const svg = tile(color).replace('<svg ', `<svg opacity='${opacity}' `).replace(/\n\s*/g, ' ').trim();
    return `url("data:image/svg+xml,${encodeSvg(svg)}")`;
};

/** Formas soltas para flutuar ao redor de seções (cada uma com sua cor). */
export const shapeSvg = {
    coxinha: (c) => `<svg viewBox='0 0 60 64' xmlns='http://www.w3.org/2000/svg'><path d='M30 2c13 17 26 33 26 44a26 26 0 0 1-52 0C4 35 17 19 30 2z' fill='${c}'/></svg>`,
    bolinha: (c) => `<svg viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'><circle cx='30' cy='30' r='28' fill='${c}'/></svg>`,
    pastel: (c) => `<svg viewBox='0 0 80 46' xmlns='http://www.w3.org/2000/svg'><path d='M2 44C2 20 19 2 40 2s38 18 38 42z' fill='${c}'/></svg>`,
    brilho: (c) => `<svg viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'><path d='M30 2l7 21 21 7-21 7-7 21-7-21-21-7 21-7z' fill='${c}'/></svg>`,
};

export const shapeUrl = (name, color) => `url("data:image/svg+xml,${encodeSvg(shapeSvg[name](color))}")`;
